import { PDFDownloadLink } from '@react-pdf/renderer';
import FlyMarketInvoicePDF from '../components/pdf/FlyMarketInvoicePDF';

// Datos del recibo de caja
const invoiceData = {
    invoiceNumber: 'RC-102',
    issueDate: new Date(),
    
    // Cliente
    companyName: '300 Tesla Automotriz',
    clientName: 'Hugo Rojas Carvajal',
    clientPhone: '3134753678',
    clientCity: 'Cali',
    clientDepartment: 'Valle del Cauca',
    
    // Servicio
    concept: 'Mensualidad del servicio de OviCatalogos del 16 de febrero al 15 de marzo de 2026',
    planType: 'Mensual',
    
    // Totales
    subtotal: 67900,
    discount: 0,
    total: 67900,
};

const GenerateInvoicePage = () => {
    // Colores de OviCatalogos
    const colors = {
        primary: '#4169E1',         // Royal Blue
        primaryDark: '#0F172A',
        accent: '#10B981',          // Verde
        purple: '#8B5CF6',          // Púrpura
        textMuted: '#94A3B8',
        light: '#F8FAFC',
        warning: '#FFA726',
    };

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: colors.light,
            padding: '40px 20px',
            fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
            <div style={{
                maxWidth: '800px',
                margin: '0 auto',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                padding: '40px'
            }}>
                {/* Header */}
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                    <h1 style={{
                        fontSize: '32px',
                        fontWeight: 'bold',
                        color: colors.primary,
                        marginBottom: '8px'
                    }}>
                        Generador de Recibo de Caja
                    </h1>
                    <p style={{ color: colors.textMuted, fontSize: '16px' }}>
                        OviCatalogos - Minymol S.A.S.
                    </p>
                </div>

                {/* Datos */}
                <div style={{
                    backgroundColor: colors.light,
                    borderRadius: '8px',
                    padding: '24px',
                    marginBottom: '32px',
                    borderLeft: `4px solid ${colors.primary}`
                }}>
                    <h3 style={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: colors.primary,
                        marginBottom: '16px'
                    }}>
                        Datos del Recibo de Caja
                    </h3>
                    
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                        <div>
                            <p style={{ fontSize: '12px', color: colors.textMuted, marginBottom: '4px' }}>Número</p>
                            <p style={{ fontSize: '14px', fontWeight: '600', color: colors.primary }}>{invoiceData.invoiceNumber}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: '12px', color: colors.textMuted, marginBottom: '4px' }}>Total</p>
                            <p style={{ fontSize: '14px', fontWeight: '600', color: colors.primary }}>
                                ${invoiceData.total.toLocaleString('es-CO')}
                            </p>
                        </div>
                        <div style={{ gridColumn: '1 / -1' }}>
                            <p style={{ fontSize: '12px', color: colors.textMuted, marginBottom: '4px' }}>Razón Social</p>
                            <p style={{ fontSize: '14px', fontWeight: '600', color: colors.primary }}>{invoiceData.companyName}</p>
                        </div>
                        <div style={{ gridColumn: '1 / -1' }}>
                            <p style={{ fontSize: '12px', color: colors.textMuted, marginBottom: '4px' }}>Cliente</p>
                            <p style={{ fontSize: '14px', fontWeight: '600', color: colors.primary }}>{invoiceData.clientName}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: '12px', color: colors.textMuted, marginBottom: '4px' }}>Teléfono</p>
                            <p style={{ fontSize: '14px', fontWeight: '600', color: colors.primary }}>{invoiceData.clientPhone}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: '12px', color: colors.textMuted, marginBottom: '4px' }}>Ciudad</p>
                            <p style={{ fontSize: '14px', fontWeight: '600', color: colors.primary }}>
                                {invoiceData.clientCity}, {invoiceData.clientDepartment}
                            </p>
                        </div>
                        <div style={{ gridColumn: '1 / -1' }}>
                            <p style={{ fontSize: '12px', color: colors.textMuted, marginBottom: '4px' }}>Concepto</p>
                            <p style={{ fontSize: '14px', fontWeight: '600', color: colors.primary }}>{invoiceData.concept}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: '12px', color: colors.textMuted, marginBottom: '4px' }}>Tipo de Plan</p>
                            <p style={{ fontSize: '14px', fontWeight: '600', color: colors.primary }}>{invoiceData.planType}</p>
                        </div>
                    </div>
                </div>

                {/* Botón de descarga */}
                <div style={{ textAlign: 'center' }}>
                    <PDFDownloadLink
                        document={<FlyMarketInvoicePDF invoice={invoiceData} />}
                        fileName={`Minymol_ReciboCaja_${invoiceData.invoiceNumber}.pdf`}
                        style={{
                            display: 'inline-block',
                            padding: '16px 32px',
                            backgroundColor: colors.accent,
                            color: 'white',
                            textDecoration: 'none',
                            borderRadius: '8px',
                            fontWeight: 'bold',
                            fontSize: '16px',
                            boxShadow: `0 4px 6px rgba(16, 185, 129, 0.3)`,
                            transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#059669';
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = `0 6px 8px rgba(16, 185, 129, 0.4)`;
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = colors.accent;
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = `0 4px 6px rgba(16, 185, 129, 0.3)`;
                        }}
                    >
                        {({ loading }) => (
                            loading ? '⏳ Generando PDF...' : '📄 Descargar Recibo de Caja'
                        )}
                    </PDFDownloadLink>
                </div>

                {/* Info adicional */}
                <div style={{
                    marginTop: '32px',
                    padding: '16px',
                    backgroundColor: '#FFF8E1',
                    borderRadius: '8px',
                    borderLeft: `4px solid ${colors.warning}`
                }}>
                    <p style={{ fontSize: '12px', color: '#E65100', margin: 0 }}>
                        <strong>Nota:</strong> El PDF se generará con el logo de OviCatalogos, información completa del cliente 
                        y datos bancarios de Minymol S.A.S. para realizar el pago.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default GenerateInvoicePage;
